import { Routes } from '@models/route';
import { lazy } from 'react';

const ClientsListing = lazy(() =>
  import('@pages/clients/ClientsListing').then((p) => ({
    default: p.ClientsListing
  }))
);

const ViewClient = lazy(() =>
  import('@pages/clients/ViewClient').then((p) => ({
    default: p.ViewClient
  }))
);

export const ClientRoutes: Routes = [
  {
    path: '/clients',
    component: ClientsListing,
    children: [
      {
        path: ':id',
        component: ViewClient
      }
    ]
  }
];
